<script setup>
import { ref, onMounted, onUnmounted, defineExpose, nextTick } from 'vue'

const info = ref({}), list = ref([])
let observer = null

// 设置观察器函数
function setupObserver() {
  if (observer) {
    observer.disconnect()
  }

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__fadeInUp')
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -60px 0px'
      }
  )

  // 观察所有 li 元素
  const elements = document.querySelectorAll('#floor_2_main .channelalbumlist1 li')
  elements.forEach((el) => {
    observer.observe(el)
  })
}

function getInfo(e, data) {
  list.value = e
  info.value = data

  // 数据更新后重新设置观察器
  nextTick(() => {
    setTimeout(() => {
      setupObserver()
    }, 100)
  })
}

onMounted(() => {
  // 组件挂载后初始化观察器
  nextTick(() => {
    setTimeout(() => {
      setupObserver()
    }, 100)
  })
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})

// 暴露方法给父组件调用
defineExpose({
  getInfo
})
</script>

<template>
  <!-- 服务范围 开始 -->
  <div id="floor_2_main">
    <div id="floor_2">
      <div class="left_title1">
        <h2><a>{{info.name}}</a></h2>
        <p>{{info.remark}}</p>
        <i></i>
      </div>
      <div class="left_body1">
        <ul class="channelalbumlist1">
          <!-- 使用固定的 animatedslow 类，移除 animate__fadeInUp -->
          <li v-for="(item,index) in list"
              :key="index"
              class="animate__animated"
              :class="['n' + (index+1), 'animate__animated']">
            <div class="info_wrap">
              <img :src="item.picUrl" width="390" height="260" />
              <div class="AlbumTitle">{{item.title}}</div>
              <p>
                {{item.introduction}}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="left_bottom1"></div>
    </div>
  </div>
  <!-- 服务范围 结束 -->
</template>

<style scoped lang="scss">
/* 可选：让动画更明显（初始透明） */
#floor_2_main {
  height: 632px;
  .channelalbumlist1 li {
    opacity: 0;
    transform: translateY(30px);

    &.animate__fadeInUp {
      opacity: 1;
      transform: translateY(0);
      animation-name: fadeInUp;
      animation-duration: 0.6s;
    }
  }
}
/* 如果你不想初始隐藏，可删除上面这行 */
.info_wrap p {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
}
</style>
